import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=6c26caeb&scoped=true"
import script from "./PaymentMethod.vue?vue&type=script&lang=ts"
export * from "./PaymentMethod.vue?vue&type=script&lang=ts"
import style0 from "./card.less?vue&type=style&index=0&id=6c26caeb&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c26caeb",
  null
  
)

export default component.exports